var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isAuth)?[(_vm.loading)?_c('div',{staticClass:"loading-container"},[_vm._v(" Loading... ")]):[_c('router-view')]]:[_c('router-view')],_c('div',{staticClass:"version"},[_vm._v("1.2.9")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }